/* TESTING THEME ONLY. "Website carnival madness" fixes (Catarina, 8 Oct 2026). Loaded on every page from layout/theme.liquid.
   Display-only overlay, so the kit files (ursa-kit-builder.js, ursa-kit-deals.js, ursa-product-tools.js) stay untouched for the Kit Manager app patches.
   1. Product tools tabs: "Bulk and cast" removed, "Kit deals" renamed "Discounted kit bundles" and moved before "Where it goes" (item 4). 17 Oct 2026: now "Bundle & Save", first.
   2. "Pairs well with" box: renamed "Discount bundle", clear per-bundle saving (10% when the pair is also a kit bundle, else 5%) (items 9, 12).
   3. Kit/bundle rows: small product photo, name links to the product, hover preview (item 12).
   4. Product page testimonials: product names and key words in bold, like the homepage (item 13).
   5. Where to buy: Europe dealers grouped by country, A to Z, with a country heading (item 5).
   6. Testimonials page: rebuilt as a filterable page with a tab per product (item 11). Testimonials are still edited in the theme editor.
   7. FAQs page: "the Audio Ltd range" reads "the Sound Devices A20s" (item 3). Customer reviews are never changed.
   Styles: assets/ursa-carnival.css. To remove: delete the two ursa-carnival lines in layout/theme.liquid. */
(function () {
  'use strict';
  var path = location.pathname.replace(/\/$/, '');
  var isProduct = /\/products\//.test(path);
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function watch(fn, root) {
    var t; fn();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fn, 80); })
      .observe(root || document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  /* ---------- Bold product names (testimonials) ---------- */
  var NAMES = ['URSA Tape Soft Strips', 'URSA Tape', 'Soft Strips', 'Sticky Strips', 'Invisi Strips', 'Furry Strips', 'URSA MiniMounts', 'URSA MiniMount', 'Circular MiniMounts', 'MiniMounts', 'MiniMount',
    'URSA Straps', 'URSA Strap', 'Waist Straps', 'Waist Strap', 'Chest Straps', 'Chest Strap', 'Back Straps', 'Back Strap', 'X-Straps', 'X-Strap', 'X Strap', 'Head Straps', 'Head Strap',
    'Thigh Straps', 'Thigh Strap', 'Ankle Straps', 'Ankle Strap', 'Live Straps', 'Live Strap', 'URSA Belts', 'URSA Belt', 'Shorties', 'Undies', 'Vesties', 'Maskies',
    'Popper Pouches', 'Popper Pouch', 'Belt Pouches', 'Belt Pouch', 'Performance Pouches', 'Performance Pouch', 'Pin-It Pouch', 'Tracker Pouch', 'Live Pouch', 'Pouch Protectors',
    'Foamie Pros', 'Foamie Pro', 'Mini Foamies', 'Foamie Sleeves', 'Foamie Pads', 'Foamie Flex', 'Foamies', 'Foamie', 'Soft Circles', 'Plush Circles', 'Fur Circles', 'FurTangles', 'Fur Tangles', 'PlushTangles',
    'Soft Sleeves', 'Plush Sleeves', 'Stickies', 'Sticky Zeros', 'Soft Soles', 'Heavy Duties', 'Heat Shields', 'Zipper Case', 'Popper Case', 'WireRig', 'Furries'];
  var WORDS = ['game changer', 'comfortable', 'secure', 'discreet', 'invisible', 'breathable', 'low profile', 'low-profile', 'durable', 'no slipping', 'stay put', 'stays put', 'stayed put', 'brilliant', 'excellent', 'amazing'];
  var boldRe = new RegExp('\\b(' + NAMES.concat(WORDS).map(function (w) { return w.replace(/[-]/g, '\\-'); }).join('|') + ')\\b', 'gi');
  function boldify(el) {
    if (!el || el.getAttribute('data-ucv-b') || el.querySelector('strong, b')) return;
    el.setAttribute('data-ucv-b', '1');
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), nodes = [];
    while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(function (n) {
      var t = n.nodeValue; boldRe.lastIndex = 0;
      if (!boldRe.test(t)) return;
      boldRe.lastIndex = 0;
      var f = document.createDocumentFragment(), last = 0, m;
      while ((m = boldRe.exec(t))) {
        if (m.index > last) f.appendChild(document.createTextNode(t.slice(last, m.index)));
        var s = document.createElement('strong'); s.textContent = m[1]; f.appendChild(s);
        last = m.index + m[1].length;
      }
      if (last < t.length) f.appendChild(document.createTextNode(t.slice(last)));
      n.parentNode.replaceChild(f, n);
    });
  }

  /* ---------- Product pages ---------- */
  if (isProduct) {
    // 1. Product tools tabs
    function tabs() {
      var tools = document.getElementById('ursa-product-tools'); if (!tools) return;
      var bulk = tools.querySelector('.upt-tab[data-tab="bulk"]');
      if (bulk) {
        if (bulk.classList.contains('is-on')) { var w0 = tools.querySelector('.upt-tab[data-tab="where"]') || tools.querySelector('.upt-tab:not([data-tab="bulk"])'); if (w0) w0.click(); }
        bulk.remove();
      }
      var kits = tools.querySelector('.upt-tab[data-tab="kits"]');
      if (!kits) return;
      // 17 Oct 2026: "Bundle & Save", first tab (was "Discounted kit bundles", before "Where it goes"). ursa-kit-patch.js item 8 does the same at source.
      if (kits.textContent.trim() !== 'Bundle & Save') kits.textContent = 'Bundle & Save';
      if (kits.parentNode.firstElementChild !== kits) kits.parentNode.insertBefore(kits, kits.parentNode.firstElementChild);
    }

    // 2. Pairs box. Pairs that are also kit bundles get 10% (Sam's rule, 8 Oct 2026).
    var TEN = { 'Belt Pouch + Pouch Clips': 1, 'Tracker Pouch + Pouch Clips': 1, 'Tracker Pouch + Clips (shoulders)': 1, 'Waist Strap + Zipper Case': 1 };
    function money(p) { return '£' + (p / 100).toFixed(2); }
    function fixBtn(card) {
      return; // 17 Oct 2026: ursa-kit-deals.js now prices it (10% off the cheapest item), so don't overwrite with 10% off everything
      var btn = card.querySelector('.ukd-add'); if (!btn) return;
      var s = btn.querySelector('s'); if (!s) return;
      var full = Math.round(parseFloat(s.textContent.replace(/[^0-9.]/g, '')) * 100); if (!full) return;
      var want = money(Math.round(full * 0.9)), tail = s.nextSibling;
      if (tail && tail.nodeType === 3 && tail.nodeValue !== want) tail.nodeValue = want;
    }
    function pairs() {
      var box = $('.ukd-pair'); if (!box) return;
      var cards = $$('.ukd-pair__card', box);
      var h = box.querySelector('.ukd-pair__h');
      var head = cards.length > 1 ? 'Discount bundles' : 'Discount bundle';
      if (h && h.getAttribute('data-ucv') !== head) { h.setAttribute('data-ucv', head); h.innerHTML = esc(head); }
      cards.forEach(function (c) {
        var t = c.querySelector('.ukd-pair__t'); if (!t) return;
        var ten = !!TEN[t.textContent.trim()];
        if (!c.querySelector('.ucv-save')) {
          var b = document.createElement('span'); b.className = 'ucv-save';
          b.textContent = 'Bundle & save'; // 17 Oct 2026 rule, every pair
          t.insertAdjacentElement('afterend', b);
        }
        if (!ten) return;
        var msg = c.querySelector('.ukd-msg');
        if (msg && /5% off/.test(msg.textContent)) msg.textContent = msg.textContent.replace('5% off', '10% off');
        fixBtn(c);
        if (!c.getAttribute('data-ucv-o')) {
          c.setAttribute('data-ucv-o', '1');
          new MutationObserver(function () { fixBtn(c); var m = c.querySelector('.ukd-msg'); if (m && /5% off/.test(m.textContent)) m.textContent = m.textContent.replace('5% off', '10% off'); })
            .observe(c, { childList: true, subtree: true, characterData: true });
        }
      });
    }

    // 3. Kit rows: photo + link + hover preview
    var cache = {};
    function lookup(title) {
      if (cache[title]) return cache[title];
      return (cache[title] = fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          var low = title.toLowerCase();
          return ps.filter(function (p) { return (p.title || '').toLowerCase() === low; })[0] || null;
        }).catch(function () { return null; }));
    }
    function img(p, w) {
      var u = (p.featured_image && p.featured_image.url) || p.image || '';
      if (!u) return '';
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    var pv = null;
    function preview(a, p, on) {
      if (!window.matchMedia('(hover: hover) and (min-width: 750px)').matches) return;
      if (!pv) { pv = document.createElement('div'); pv.className = 'ucv-pv'; pv.setAttribute('aria-hidden', 'true'); document.body.appendChild(pv); }
      if (!on) { pv.classList.remove('is-on'); return; }
      pv.innerHTML = '<img alt="" src="' + esc(img(p, 360)) + '"><strong>' + esc(p.title) + '</strong><span>' + esc(p.price ? 'From £' + Number(p.price).toFixed(2) : '') + '</span>';
      var r = a.getBoundingClientRect();
      var left = Math.min(window.innerWidth - 220, Math.max(12, r.left));
      var top = r.top - 238; if (top < 12) top = r.bottom + 10;
      pv.style.left = left + 'px'; pv.style.top = top + 'px';
      pv.classList.add('is-on');
    }
    function rows() {
      $$('.ukd-row').forEach(function (row) {
        var b = row.querySelector(':scope > b'); if (!b || b.getAttribute('data-ucv')) return;
        b.setAttribute('data-ucv', '1');
        var title = b.textContent.trim();
        lookup(title).then(function (p) {
          if (!p || !p.url) return;
          var a = document.createElement('a');
          a.className = 'ucv-item'; a.href = p.url.split('?')[0];
          a.innerHTML = (img(p, 80) ? '<img alt="" width="32" height="32" loading="lazy" src="' + esc(img(p, 80)) + '">' : '') + '<span>' + esc(title) + '</span>';
          a.addEventListener('mouseenter', function () { preview(a, p, true); });
          a.addEventListener('mouseleave', function () { preview(a, p, false); });
          a.addEventListener('click', function (e) { e.stopPropagation(); });
          b.textContent = ''; b.appendChild(a);
        });
      });
    }

    // 4. Testimonials
    function quotes() { $$('[id*="__testimonial_"] blockquote, [id*="__testimonial_"] .ut-quote__text').forEach(boldify); }

    watch(function () { tabs(); pairs(); rows(); quotes(); });
  }

  /* ---------- Where to buy: Europe by country ---------- */
  if (/\/pages\/(where-to-buy|store-locator)/.test(path)) {
    function country(li) {
      var line = (li.innerText || '').split('\n').filter(function (t) { return /\(EUROPE\)/i.test(t); })[0];
      if (line) { var m = line.replace(/\(EUROPE\)/i, '').split(','); var c = m[m.length - 1].trim(); if (c) return c; }
      var f = li.querySelector('.flag-wrapper img');
      if (f) {
        var n = (f.getAttribute('src') || '').split('?')[0].split('/').pop().replace(/\.[a-z]+$/i, '').replace(/[_-]?\d+x\d+$/, '').replace(/[_-]+/g, ' ').trim();
        if (n && !/untitled/i.test(n)) return n.charAt(0).toUpperCase() + n.slice(1);
      }
      var a = (li.getAttribute('data-address') || '').split(',').pop().trim();
      return a || 'Other';
    }
    function europe() {
      var g = $$('.stockist-group').filter(function (x) { var t = x.querySelector('.group-title'); return t && /^europe$/i.test(t.textContent.trim()); })[0];
      if (!g) return;
      var ul = g.querySelector('ul.list-stores'); if (!ul) return;
      var lis = $$(':scope > li.stockist', ul); if (!lis.length) return;
      if (ul.getAttribute('data-ucv') === String(lis.length)) { heads(ul); return; }
      ul.setAttribute('data-ucv', String(lis.length));
      $$(':scope > li.ucv-country', ul).forEach(function (h) { h.remove(); });
      lis.forEach(function (li) { li._c = country(li); });
      lis.sort(function (a, b) { return a._c.localeCompare(b._c) || (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || ''); });
      var cur = '';
      lis.forEach(function (li) {
        if (li._c !== cur) { cur = li._c; var h = document.createElement('li'); h.className = 'ucv-country'; h.setAttribute('aria-hidden', 'false'); h.textContent = cur; ul.appendChild(h); }
        ul.appendChild(li);
      });
      heads(ul);
    }
    function heads(ul) {
      var h = null, any = false;
      $$(':scope > li', ul).forEach(function (li) {
        if (li.classList.contains('ucv-country')) { if (h) h.hidden = !any; h = li; any = false; return; }
        if (!li.hidden && getComputedStyle(li).display !== 'none') any = true;
      });
      if (h) h.hidden = !any;
    }
    watch(europe, document.body);
  }

  /* ---------- Testimonials page ---------- */
  if (/\/pages\/all-ursa-testimonials$/.test(path) && !$('.ucv-tst')) {
    var CATS = [
      ['Waist Straps', /waist strap/i], ['Chest Straps', /chest strap/i], ['Back Straps', /back ?strap/i], ['X-Straps', /x[- ]?strap/i], ['Head Straps', /head ?strap/i],
      ['Thigh Straps', /thigh strap/i], ['Ankle Straps', /ankle strap/i], ['Live Straps', /live strap/i], ['URSA Belts', /ursa belt/i],
      ['Performance Range', /shorties|undies|vesties|maskie/i], ['Pouches', /pouch/i],
      ['MiniMounts', /minimount/i], ['Foamies', /foamie/i], ['Circles', /(soft|plush|fur) circle/i], ['FurTangles', /fur ?tangle|plush ?tangle/i], ['Sleeves', /sleeve/i],
      ['Stickies', /stick(y|ies)|zeros/i], ['URSA Tape', /ursa tape|soft strips|invisi|furry strip|moleskin/i], ['Soft Soles', /soft soles|heavy dut/i], ['WireRig', /wire ?rig/i], ['Heat Shields', /heat shield/i]
    ];
    function readItems() {
      var out = [];
      $$('#MainContent > .shopify-section').forEach(function (sec) {
        $$('.group-block', sec).forEach(function (gb) {
          if ($$('.group-block', gb).some(function (x) { return x.querySelector('h4'); })) return; // innermost blocks only
          var h = gb.querySelector('h4'); if (!h) return;
          var name = h.textContent.trim(); if (!name) return;
          var ps = $$('p', gb).filter(function (p) { return p.textContent.trim(); });
          var q = ps.filter(function (p) { return p.querySelector('em, i'); })[0] || ps.slice().sort(function (a, b) { return b.textContent.length - a.textContent.length; })[0];
          if (!q) return;
          var role = ps.filter(function (p) { return p !== q && p.textContent.trim().length < 80; })[0];
          out.push({ n: name, r: role ? role.textContent.trim() : '', q: q.innerHTML.replace(/<\/?(em|i)>/g, '').trim(), t: q.textContent });
        });
      });
      return out;
    }
    function build() {
      var items = readItems(); if (items.length < 3) return false;
      var counts = {};
      items.forEach(function (it) {
        it.c = CATS.filter(function (c) { return c[1].test(it.t); }).map(function (c) { return c[0]; });
        if (!it.c.length) it.c = ['General'];
        it.c.forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
      });
      var order = CATS.map(function (c) { return c[0]; }).concat(['General']).filter(function (c) { return counts[c]; });
      var wrap = document.createElement('section'); wrap.className = 'ucv-tst';
      wrap.innerHTML = '<header class="ucv-tst__hero"><p class="ucv-tst__eb">Trusted on set</p><h1 class="ucv-tst__title">What sound teams say</h1>' +
        '<p class="ucv-tst__lead">' + items.length + ' testimonials from sound mixers, recordists and theatre crews. Pick a product to see what people say about it.</p></header>' +
        '<nav class="ucv-tst__bar" aria-label="Filter testimonials by product"><div class="ucv-tst__tabs" role="tablist">' +
        '<button type="button" role="tab" aria-selected="true" data-c="">All <span>' + items.length + '</span></button>' +
        order.map(function (c) { return '<button type="button" role="tab" aria-selected="false" data-c="' + esc(c) + '">' + esc(c) + ' <span>' + counts[c] + '</span></button>'; }).join('') +
        '</div></nav><div class="ucv-tst__grid" aria-live="polite">' +
        items.map(function (it) {
          return '<figure class="ucv-tst__card" data-c="|' + esc(it.c.join('|')) + '|"><blockquote>' + it.q + '</blockquote><figcaption><strong>' + esc(it.n) + '</strong>' +
            (it.r ? '<span>' + esc(it.r) + '</span>' : '') + '</figcaption><p class="ucv-tst__tags">' + it.c.map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('') + '</p></figure>';
        }).join('') + '</div>';
      var main = $('#MainContent > [id$="__main"]') || $('#MainContent > .shopify-section');
      main.insertAdjacentElement('afterend', wrap);
      document.documentElement.classList.add('ucv-tst-on');
      $$('.ucv-tst__card blockquote', wrap).forEach(boldify);
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-c]'); if (!b || b.tagName !== 'BUTTON') return;
        var c = b.getAttribute('data-c');
        $$('.ucv-tst__tabs button', wrap).forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
        $$('.ucv-tst__card', wrap).forEach(function (f) { f.hidden = !!c && f.getAttribute('data-c').indexOf('|' + c + '|') < 0; });
      });
      return true;
    }
    if (!build()) document.addEventListener('DOMContentLoaded', build);
  }

  /* ---------- FAQs: Audio Ltd range ---------- */
  if (/\/pages\/faqs$/.test(path)) {
    watch(function () {
      var w = document.createTreeWalker(document.getElementById('MainContent') || document.body, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) if (/the Audio Ltd range/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/the Audio Ltd range/g, 'the Sound Devices A20s');
    });
  }
})();
